import cloneDeep from 'lodash/cloneDeep';

import { REPORT_DETAIL_DATA_KEY } from 'src/redux/constants';
import type { IViewDataInitialState } from 'src/redux/viewData/types';

export const receivePostAcrInfoBoxSuccess = (
  state: IViewDataInitialState,
  action: { payload: Record<string, unknown> },
): IViewDataInitialState => {
  const newState = cloneDeep(state);
  newState[REPORT_DETAIL_DATA_KEY].data = {
    ...newState[REPORT_DETAIL_DATA_KEY].data,
    ...action.payload,
  };
  return newState;
};
